import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  Legend,
  LabelList,
  ResponsiveContainer,
} from "recharts";
import formatNumber from "../../../helpers/formatNumber";
import Image from "../../Image/Image";

const CustomTooltip = ({ active, payload }) => {
  if (!active || !payload || payload.length === 0) return null;

  const entry = payload[0]?.payload;
  return (
    <div className="bg-dark text-white p-2 rounded shadow-sm border border-secondary">
      <strong>{entry?.label}</strong>
      <div>Dividende: {formatNumber(entry?.totalDividend) ?? "–"} €</div>
    </div>
  );
};

const SimpleBarChart = ({
  labels,
  datasets,
  datasetLabels = [],
  colors = [],
}) => {
  // Daten vorbereiten
  const data = labels?.map((label, i) => {
    const obj = { label };
    datasets.forEach((dataset, idx) => {
      const key = datasetLabels[idx] || `Serie${idx + 1}`;
      obj[key] = dataset[i];
    });
    return obj;
  });

  return (
    <div className="pie-chart-container">
      <ResponsiveContainer width="80%" height="85%">
        <BarChart data={data} layout="vertical">
          <XAxis type="number" tickFormatter={formatNumber} hide />
          <YAxis type="category" dataKey="label" hide />
          <Tooltip content={<CustomTooltip />} />
          {datasets.map((_, idx) => (
            <Bar
              key={idx}
              dataKey={datasetLabels[idx] || `Serie${idx + 1}`}
              fill={colors[idx] || "#8884d8"}
            />
          ))}
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};
export default SimpleBarChart;
